import { useCallback, useEffect, useRef, useState } from 'react';
import { TtsStreamer } from '../components/TtsStreamer';

/**
 * Hook to manage text-to-speech preferences and state.
 * Returns the current TTS settings and a rendered TtsStreamer element.
 */
export default function useTtsControls(userId) {
  const [enableTts, setEnableTts] = useState(() => {
    const saved = localStorage.getItem('enableTts');
    return saved ? JSON.parse(saved) : false;
  });

  const [ttsState, setTtsState] = useState({ isLoading: false, isPlaying: false });
  const ttsRef = useRef(null);

  const toggleTts = useCallback(() => setEnableTts((prev) => !prev), []);

  useEffect(() => {
    localStorage.setItem('enableTts', JSON.stringify(enableTts));
  }, [enableTts]);

  const TtsStreamerElement = (
    <TtsStreamer ref={ttsRef} userId={userId} onStateChange={setTtsState} />
  );

  return { enableTts, toggleTts, ttsState, ttsRef, TtsStreamerElement };
}
